import angular from 'angular';

import template from './patientConnection.merge.html';
import './patientConnection.merge.less';

class MergeController {
    constructor() {
        'ngInject';
    }

    $onInit() {
        this.currentScreen = 'mainSelection';
        this.mergeToProfile = {};
    }

    $onChanges(changes) {
        if (changes.profile) {
            this.profiles = this.profiles.map(pr => angular.copy(pr));
        }
        if (changes.patient) {
            this.patient = angular.copy(this.patient);
        }
        if (changes.careTeam) {
            this.careTeam = angular.copy(this.careTeam);
        }
    }

    setCurrentScreen(screenName) {
        this.currentScreen = screenName;
    }

    returnToMainScreen() {
        this.setCurrentScreen('mainSelection');
    }

    setMergeToProfile(profile) {
        this.mergeToProfile = profile;
        this.currentScreen = 'mergeProfileScreen';
    }

    confirmMergeProfile() {
        this.onMergeProfile({
            $event: {
                profile: this.mergeToProfile
            }
        });
    }

    cancelMergeProfile() {
        this.mergeToProfile = {};
        this.setCurrentScreen('addNewProfile');
    }

    confirmAddAsNewProfile() {
        this.onAddAsNewProfile();
    }

    confirmCancelShare() {
        this.onCancelShare();
    }

}

export const MergeComponent = {
    name: 'mmsPatientConnectionMerge',
    component: {
        template: template,
        controller: MergeController,
        bindings: {
            profiles: '<',
            patient: '<',
            careTeam: '<',

            onAddAsNewProfile: '&',
            onMergeProfile: '&',
            onCancelShare: '&'
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/pages/patientConnection/merge/patientConnection.merge.component.js